import React, { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import useApi from '../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import InputField from '../../../utils/InputField';

function EditCustomerModal({ closeEditModal, setReloadKey, setInfoReloadKey, data }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setMessage } = useTemplate();
    const { put } = useApi();
    const [formData, setFormData] = useState({
        CustomerId: data?.id,
        AgencyId: data?.agencyId || 0,
        FirstName: data?.userInfo?.firstName || data.firstName || '',
        LastName: data?.userInfo?.lastName || data?.lastName || '',
        Organization: data?.organization || '',
        ShortName: data?.shortName || '',
        ShortCode: data?.shortCode || '',
        PrimaryEmail: data?.primaryEmail || data?.primaryEmail || '',
        PrimaryPhone: data?.userInfo?.phone || data?.primaryPhone || '',
        Status: data?.userInfo?.status || data?.status || 'active'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const handleUpdateCustomer = (e) => {
        e.preventDefault();
        setLoading(true);
        put(`api/agency/${formData.AgencyId}/customer/${formData.CustomerId}/update`, formData)
            .then(({ error, referenceName, message }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                closeEditModal();
                setReloadKey((d) => d + 1);
                setInfoReloadKey((d) => d + 1);
            })
            .catch((ex) => {
                setMessage({ type: 'error', text: ex?.message || 'Failed to update customer' });
            })
            .finally(() => setLoading(false));
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleUpdateCustomer} className="flex flex-col gap-4">
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <div className="flex justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required={!data?.isBillToAgency}
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Doe"'
                    formData={formData}
                    onChange={handleChange}
                    required={!data?.isBillToAgency}
                />
            </div>
            <div className="flex justify-between items-center gap-4">
                <InputField
                    label="Short Name"
                    name="ShortName"
                    placeholder='e.g. "John S."'
                    formData={formData}
                    onChange={handleChange}
                />
                <InputField
                    label="Short Code"
                    name="ShortCode"
                    placeholder='e.g. "JS"'
                    formData={formData}
                    onChange={handleChange}
                />
            </div>
            <div className="flex justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="PrimaryEmail"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required={!data?.isBillToAgency}
                />
                <InputField
                    label="Phone Number"
                    name="PrimaryPhone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required={!data?.isBillToAgency}
                />
            </div>
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeEditModal()} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default EditCustomerModal;
